<!-- 饼图的配置 -->
<template>
  <div>
    <el-collapse accordion class="average-width">
      <el-collapse-item name="7865" title="饼图设置">
        <el-form-item label="横轴中心" size="small">
          <div style="display: flex;width: 100%;">
            <el-input-number v-model="main.activeOption.xCenter" :min="0" :max="100" controls-position="right"/>
            <span class="color b pl-16">%</span>
          </div>
        </el-form-item>
        <el-form-item label="纵轴中心" size="small">
          <div style="display: flex;width: 100%;">
            <el-input-number v-model="main.activeOption.yCenter" :min="0" :max="100" controls-position="right"/>
            <span class="color b pl-16">%</span>
          </div>

        </el-form-item>
        <el-form-item label="内半径" size="small">
          <div style="display: flex;width: 100%;">
            <el-input-number v-model="main.activeOption.xRadius" :min="0" :max="100" controls-position="right"/>
            <span class="color b pl-16">%</span>
          </div>

        </el-form-item>
        <el-form-item label="外半径" size="small">
          <div style="display: flex;width: 100%;">
            <el-input-number v-model="main.activeOption.yRadius" :min="0" :max="100" controls-position="right"/>
            <span class="color b pl-16">%</span>
          </div>

        </el-form-item>
        <el-form-item label="边框圆角" size="small">
          <el-input-number
            v-model="main.activeOption.borderRadius"
            :min="0"
            :max="100"
            size="small"
          />
        </el-form-item>
        <el-form-item label="边框颜色" size="small">
          <el-color-picker
            :predefine="predefineColors"
            v-model="main.activeOption.borderColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="边框宽度" size="small">
          <el-input-number
            v-model="main.activeOption.borderWidth"
            :min="0"
            :max="100"
            size="small"
          />
        </el-form-item>
        <el-form-item label="中央提示语">
          <el-switch v-model="main.activeOption.showCenterLabel" size="small"></el-switch>
        </el-form-item>
        <!--        <el-form-item label="设置为环形">-->
        <!--          <el-switch v-model="main.activeOption.radius"></el-switch>-->
        <!--        </el-form-item>-->
        <el-form-item label="南丁格尔玫瑰">
          <el-switch v-model="main.activeOption.roseType" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="自动排序">
          <el-switch v-model="main.activeOption.sort" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="不展示零">
          <el-switch v-model="main.activeOption.notCount" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="不展示光圈">
          <el-switch v-model="main.activeOption.notShowInner" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="关闭放大效果">
          <el-switch v-model="main.activeOption.notShowEmphasis" size="small"></el-switch>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item name='345' title="图例设置">
        <el-form-item label="显示图例">
          <el-switch v-model="main.activeOption.legend" size="small"></el-switch>
        </el-form-item>
        <template v-if="main.activeOption.legend">
          <el-form-item label="图例内容">
            <el-radio-group v-model="main.activeOption.showPercentage" size="small">
              <el-radio-button label="percentage">百分比</el-radio-button>
              <el-radio-button label="value">数值</el-radio-button>
              <el-radio-button label="both">同时展示</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="图例间隔">
            <el-input-number v-model="main.activeOption.blankInterval" :min="0" size="small" controls-position="right"/>
          </el-form-item>
          <el-form-item label="图例类型">
            <el-radio-group v-model="main.activeOption.legendType" size="small">
              <el-radio-button label="legend">默认图例</el-radio-button>
              <el-radio-button label="indexCard">指标卡</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="图例方向">
            <el-radio-group @change="directionChange" v-model="main.activeOption.layoutType" size="small">
              <el-radio-button label="row">竖排</el-radio-button>
              <el-radio-button label="column-reverse">横排</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="main.activeOption.legendType === 'indexCard'" label="图例位置">
            <el-select clearable v-model="main.activeOption.legendPosition" size="small">
              <template v-if="main.activeOption.layoutType !== 'row'">
                <el-option label="上方居左" value="tl"></el-option>
                <el-option label="上方居中" value="tc"></el-option>
                <el-option label="上方居右" value="tr"></el-option>
                <el-option label="下方居左" value="bl"></el-option>
                <el-option label="下方居中" value="bc"></el-option>
                <el-option label="下方居右" value="br"></el-option>
              </template>
              <template v-else>
                <el-option label="左侧居左" value="ll"></el-option>
                <el-option label="左侧居中" value="lc"></el-option>
                <el-option label="左侧居右" value="lr"></el-option>
                <el-option label="右侧居左" value="rl"></el-option>
                <el-option label="右侧居中" value="rc"></el-option>
                <el-option label="右侧居右" value="rr"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item v-else label="图例位置">
            <el-select v-model="main.activeOption.legendPosition" size="small">
              <template v-if="main.activeOption.layoutType !== 'row'">
                <el-option label="上方居左" value="tl"></el-option>
                <el-option label="上方居中" value="tc"></el-option>
                <el-option label="上方居右" value="tr"></el-option>
                <el-option label="下方居左" value="bl"></el-option>
                <el-option label="下方居中" value="bc"></el-option>
                <el-option label="下方居右" value="br"></el-option>
              </template>
              <template v-else>
                <el-option label="左侧居上" value="lt"></el-option>
                <el-option label="左侧居中" value="lc"></el-option>
                <el-option label="左侧居下" value="lb"></el-option>
                <el-option label="右侧居上" value="rt"></el-option>
                <el-option label="右侧居中" value="rc"></el-option>
                <el-option label="右侧居下" value="rb"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="图例排序">
            <el-select v-model="main.activeOption.legendOrder" size="small">
              <el-option label="默认" value="default"></el-option>
              <el-option label="升序" value="ascend"></el-option>
              <el-option label="降序" value="descend"></el-option>
            </el-select>
          </el-form-item>
          <template v-if="main.activeOption.legendType !== 'indexCard'">
            <el-form-item label="图例标示">
              <el-select clearable v-model="main.activeOption.legendIcon" size="small">
                <el-option label="默认" value=""></el-option>
                <el-option label="圆形" value="circle"></el-option>
                <el-option label="矩形" value="rect"></el-option>
                <el-option label="圆角矩形" value="roundRect"></el-option>
                <el-option label="三角形" value="triangle"></el-option>
                <el-option label="宝石" value="diamond"></el-option>
                <el-option label="别针" value="pin"></el-option>
                <el-option label="箭头" value="arrow"></el-option>
                <el-option label="无" value="none"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="标示大小">
              <el-input-number style="width: 100px" v-model="main.activeOption.legendW" :min="0" :max="100" size="small"
                               controls-position="right"/>
              <span style="color: #fff;width: 20px;text-align: center">*</span>
              <el-input-number style="width: 100px" v-model="main.activeOption.legendH" :min="0" :max="100" size="small"
                               controls-position="right"/>
            </el-form-item>
            <el-form-item label="字体大小">
              <el-input-number style="width: 100px" v-model="main.activeOption.legendFontSize" :min="0" :max="100"
                               size="small" controls-position="right"/>
            </el-form-item>
            <el-form-item labelAlign="left" label="字体颜色">
              <el-color-picker :predefine="predefineColors"
                               v-model="main.activeOption.legendFontColor"></el-color-picker>
            </el-form-item>
            <el-form-item label="是否分页">
              <el-switch v-model="main.activeOption.isCurrent"></el-switch>
            </el-form-item>
          </template>
          <el-form-item v-if="main.activeOption.legendType === 'indexCard'" label="图形占比" size="small">
            <div style="display: flex;width: 100%;">
              <el-input-number v-model="main.activeOption.layoutNumber" :min="0" :max="100" controls-position="right"/>
              <span class="color b pl-16">%</span>
            </div>
          </el-form-item>
        </template>
      </el-collapse-item>
      <IndexCardSet v-if="main.activeOption.legend && main.activeOption.legendType === 'indexCard'"></IndexCardSet>
      <el-collapse-item title="环内指标设置">
        <el-form-item label="是否显示总值">
          <el-switch v-model="main.activeOption.isShowTotalIndex" size="small"></el-switch>
        </el-form-item>
        <el-form-item labelAlign="left" label="标题颜色">
          <el-color-picker
            :predefine="predefineColors"
            v-model="main.activeOption.totalLabelColor"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" label="标题大小">
          <el-input-number
            v-model="main.activeOption.totalLabelFontSize"
            :min="0"
            :max="100"
            size="small"
          />
        </el-form-item>
        <el-form-item labelAlign="left" label="标题行高">
          <el-input-number
            v-model="main.activeOption.totalLabelLineHeight"
            :min="0"
            :max="100"
            size="small"
          />
        </el-form-item>
        <el-form-item labelAlign="left"  label="标题粗细">
          <el-select v-model="main.activeOption.totalLabelFontWeight" size="small">
            <el-option
              v-for="item in dicOption.fontWeight"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item labelAlign="left" label="折行字数">
          <el-input-number
            v-model="main.activeOption.totalLabelWrapNumber"
            :min="0"
            :max="100"
            size="small"
          />
        </el-form-item>
        <el-form-item labelAlign="left" label="值颜色">
          <el-color-picker
            :predefine="predefineColors"
            v-model="main.activeOption.totalValueColor"></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" label="值大小">
          <el-input-number
            v-model="main.activeOption.totalValueFontSize"
            :min="0"
            :max="100"
            size="small"
          />
        </el-form-item>
        <el-form-item labelAlign="left"  label="值粗细">
          <el-select v-model="main.activeOption.totalValueFontWeight" size="small">
            <el-option
              v-for="item in dicOption.fontWeight"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item labelAlign="left" label="值标题间距">
          <el-input-number
            v-model="main.activeOption.totalValueTop"
            :min="0"
            :max="100"
            size="small"
          />
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script setup>
import {CARD_TYPE, predefineColors} from "@/option/common/dict.js";
import { dicOption } from "@/option/config";
import IndexCardSet from '@/components/indexCard/option.vue'
</script>
<script>
export default {
  name: "pieCircleIndex",
  inject: ["main"],
  data() {
    return {
      dicOption: dicOption,
    }
  },
  methods: {
    directionChange(v) {
      if (v === 'row') {
        this.main.activeOption.legendPosition = 'rc'
      } else {
        this.main.activeOption.legendPosition = 'tc'
      }
    }
  }
};
</script>

<style></style>